<template>
	<el-dialog
		:title="title"
		:visible.sync="editorVisible"
		v-loading="loadingDM"
		:append-to-body="true"
	>
		<el-alert class="mb-3" :title="alertInfo" type="error" :closable="false" v-if="alertInfo"></el-alert>
		<el-form
			ref="editorForm"
			:model="batchConfirmInfo"
			status-icon
			label-position="left"
			label-width="120px"
			size="mini"
			@submit.native.prevent
		>
			<div class="row">
				<div
					:class="key.col?'col-md-'+key.col:'col-md-12'"
					v-for="(key,index) in editorFields"
					:key="index"
				>
					<el-form-item :prop="key.name">
						<template v-slot:label>
							<el-checkbox
								v-model="batchConfirmInfo.checked[key.name]"
							>{{dataModels[dataModelName][key.name].show_name}}</el-checkbox>
						</template>
						<field-show
							:record-model="dataModelName"
							:field-info="dataModels[dataModelName][key.name]"
							:value="batchConfirmInfo.info[key.name]"
							:field-key="key"
							:params="key.params"
							v-if="key.isOnlyShow"
						></field-show>
						<field-editor
							:width="key.width"
							:tips="key.tips"
							v-model="batchConfirmInfo.info[key.name]"
							:field-info="dataModels[dataModelName][key.name]"
							:record-model="dataModelName"
							:params="key.params"
							:ref="'key_'+key.name"
							v-else
						></field-editor>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="mini" @click="visible = false">取 消</el-button>
			<el-button size="mini" type="primary" @click="doConfirmEdit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
import LoadDM from "@/mixins/LoadDM.js";

export default {
	mixins: [LoadDM],
	data() {
		return {
			dataModelName: "Order",
		};
	},
	computed: {
		editorFields() {
			if (this.isIncome) {
				return [
					{
						name: "total_price",
						rules: ["required"],
						col: 6,
					},
					{
						name: "pay_method",
						rules: ["required"],
						col: 6,
					},

					{
						name: "payed_at",
						sortable: "custom",
						rules: ["required"],
						col: 6,
					},

					{
						name: "desc",
						sortable: "custom",
					},
					{
						name: "primary_img",
					},
				];
			} else {
				return [
					{
						name: "supplier",
						sortable: "custom",
						isOnlyShow: true,
						col: 6,
					},
					{
						name: "total_price",
						rules: ["required"],
						col: 6,
					},
					{
						name: "pay_method",
						rules: ["required"],
						col: 6,
					},

					{
						name: "payed_at",
						sortable: "custom",
						rules: ["required"],
						col: 6,
					},
					{
						name: "name",
						sortable: "custom",
						rules: ["required"],
					},
					{
						name: "desc",
						sortable: "custom",
					},
					{
						name: "primary_img",
					},
				];
			}
		},
		editorVisible: {
			get: function() {
				return this.show;
			},
			set: function(val) {
				this.$emit("update:show", val);
			},
		},
		title() {
			if (this.isIncome) {
				return "确认已经收到 " + this.batchConfirmInfo.count + " 笔款项, 是否继续?";
			} else {
				return "确认已经完成支付, 是否继续? ";
			}
		},
		alertInfo() {
			if (this.isIncome) {
				return "请在需要批量编辑的字段前打勾。总金额是全部订单的金额，如有折扣将平均分布在所有订单当中，以0.01为最小精度";
			} else {
				return "如果实际并未发生付款退款行为，请直接删除订单，无需退款";
			}
		},
		handlerUrl() {
			if (this.isIncome) {
				return "orderm/do_has_payed_batch/";
			} else {
				return "orderm/do_return_payed_batch/";
			}
		},
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		batchConfirmInfo: {
			type: Object,
			default: function() {
				return {
					count: 0,
					info: {
						total_price: 0,
						total_price6: 0,
            discount_total: 0,
						pay_method: {
							index: 30,
							name: "挂帐/月结",
						},
						payed_at: 0,
						desc: "",
						primary_img: "",
					},
					recordIds: [],
					checked: {
						total_price: false,
						pay_method: false,
						payed_at: false,
						desc: false,
						primary_img: false,
					},
				};
			},
		},
		isIncome: {
			type: Boolean,
			default: true,
		},
	},
	mounted() {},
	methods: {
		doConfirmEdit() {
			this.$refs["editorForm"].validate(valid => {
				if (!valid) {
					return false;
				}
				this.$axios
					.post(this.handlerUrl, this.batchConfirmInfo)
					.then(json => {
						this.$message.success("成功");
						this.editorVisible = false;
						this.$emit("change");
					})
					.catch(json => {
						this.$message.error(json.data.msg);
					});
			});
		},
	},
};
</script>